import AsyncStorage from '@react-native-async-storage/async-storage';

export async function getToken() {
    const token = await AsyncStorage.getItem('@PuzliApp:token');
    const tokenFormat = JSON.parse(String(token));
    return tokenFormat;
}
